// extracted by mini-css-extract-plugin
export default {"container":"CastingChat_container__AoQIy"};